import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Tooltip,
} from "@bleu.builders/ui";
import { PlusIcon } from "lucide-react";
import React from "react";

import { useFeatures } from "#/contexts/FeaturesContext";
import { useUser } from "#/contexts/UserContext";
import { canCreateReusableDiagnosisLink } from "#/lib/permissions";

import { AnswerNewDiagnosis } from "./AnswerNewDiagnosis";
import { MultiDiagnosisFeatureNotice } from "./MultiDiagnosisFeatureNotice";
import { MultipleDiagnosisLinkCreation } from "./MultipleDiagnosisLinkCreation";
import { SingleDiagnosisLinkCreation } from "./SingleDiagnosisLinkCreation";

const TooltipedAction = ({
  children,
  description,
}: {
  children: React.ReactNode;
  description: string;
}) => {
  return (
    <Tooltip
      content={description}
      className="bg-background text-foreground max-w-xs border border-muted-foreground"
    >
      {children}
    </Tooltip>
  );
};

export function DiagnosesActions() {
  const { features } = useFeatures();
  const { user } = useUser();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="flex gap-1">
          <PlusIcon /> Novo Diagnóstico
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="flex flex-col justify-start items-start">
        <TooltipedAction description="Cadastre as informações da empresa para ter um diagnóstico tributário.">
          <button className="w-full">
            <AnswerNewDiagnosis />
          </button>
        </TooltipedAction>
        <TooltipedAction description="Cada link aceita uma única resposta. Utilize essa opção para que outra pessoa insira as informações de um cliente específico.">
          <button className="w-full">
            <SingleDiagnosisLinkCreation />
          </button>
        </TooltipedAction>
        <TooltipedAction description="Não possui limite de respostas. Gere um único link de diagnóstico e encaminhe para quantos clientes quiser.">
          <button className="w-full">
            {features.show_create_reusable_diagnosis_link_creation ||
            canCreateReusableDiagnosisLink(user) ? (
              <MultipleDiagnosisLinkCreation />
            ) : (
              <MultiDiagnosisFeatureNotice />
            )}
          </button>
        </TooltipedAction>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
